import { IExpiredDonorRow } from '@nkr/store/reports';
import { OverlayTrigger, Popover, Table } from 'react-bootstrap';

interface IProps {
    data: IExpiredDonorRow[],
    formattedStartDate: string,
    formattedEndDate: string
}

const ExpiredRuleOuts = (props: IProps) => {
    let { data, formattedStartDate, formattedEndDate } = props;

    return (
        <Table bordered striped>
            <thead>
                <tr>
                    <th colSpan={2} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>Expired Rule-Outs{' '}<OverlayTrigger trigger={['hover', 'click']} placement='bottom' overlay={<Popover id='expired-rule-outs-info'>Expired registrations default to 90 days from registration date, but can be shorter per center selection.</Popover>}><span className='glyphicon glyphicon-info-sign'></span></OverlayTrigger></span> <span style={{ float: 'right' }}>({formattedStartDate} - {formattedEndDate})</span></th>
                </tr>
                <tr>
                    <th style={{ backgroundColor: '#f0f0f0' }}>Last Completed Step</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}>Percent</th>
                </tr>
            </thead>
            <tbody>
                {data.length === 0 && (
                    <tr>
                        <td colSpan={2} style={{ textAlign: 'center' }}>No data</td>
                    </tr>
                )}
                {data.map((row, i) => (
                    <tr key={i}>
                        <td>{row.lastCompletedStepDescription}</td>
                        <td style={{ textAlign: 'center' }}>{row.percentOfTotal}%</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default ExpiredRuleOuts;
